import { render, staticRenderFns } from "./WarehouseDashboard.vue?vue&type=template&id=39a4cfce"
import script from "./WarehouseDashboard.vue?vue&type=script&lang=js"
export * from "./WarehouseDashboard.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDashboard.vue?vue&type=style&index=0&id=39a4cfce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports